import $ from "jquery";
import "jquery-deparam";

export default function setupAjax() {
  // timestamp all ajax requests
  $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
    var url = options.url.split("?");
    if (url[1]) {
      var params = $.deparam(url[1]);
      if (!params._) {
        params._ = (new Date()).getTime();
        options.url = url[0] + "?" + $.param(params);
      }
    }
  });
}
